<div
  class="decline-item-list"
  role="group"
  tabindex="0"
  [attr.aria-label]="listLabel"
  [attr.data-testid]="listTestId || null"
>
  <div class="decline-item-list__item" *ngFor="let item of items" [attr.data-testid]="itemTestId || null">
    <span class="decline-item-list__site">{{ item.siteNumber == null ? '' : '#' + item.siteNumber }}</span>
    <span class="decline-item-list__product">{{ item.title }}</span>
    <span class="decline-item-list__status">{{ item.statusLabel }}</span>
  </div>
</div>
